export const HIGHLIGHTED_LINKS_SHORTCODE = '[#highlighted-links#]'
